var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4E6DD;}\r\n\t.st1{fill:#80D4C4;}\r\n\t.st2{fill:#D2F0EA;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#FBD872;}\r\n\t.st5{fill:#DB7767;}\r\n\t.st6{fill:#F38E7A;}\r\n\t.st7{fill:#F6AF62;}\r\n\t.st8{fill:#32A48E;}\r\n\t.st9{fill:#A38FD8;}\r\n\t.st10{fill:#7C64BD;}\r\n\t.st11{fill:#EAA157;}\r\n\t.st12{fill:#9681CF;}\r\n\t.st13{fill:#F9C46A;}\r\n\t.st14{fill:#CE6B61;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M52,10.51H12c-2.21,0-4,1.79-4,4v22.16c0,2.21,1.79,4,4,4h40c2.21,0,4-1.79,4-4V14.51   C56,12.3,54.21,10.51,52,10.51z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    height: 5.78,
    width: 48,
    x: 8,
    y: 16.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 14.36,
    cy: 27.31,
    r: 2.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.92,35.66v-3.21c0-4.76-3.87-8.63-8.63-8.63s-8.63,3.87-8.63,8.63v3.21c-1.55,0.23-2.74,1.55-2.74,3.17   v11.45c0,1.77,1.44,3.21,3.21,3.21h16.32c1.77,0,3.21-1.44,3.21-3.21V38.83C50.66,37.22,49.47,35.9,47.92,35.66z M39.29,27.04   c2.99,0,5.42,2.43,5.42,5.42v3.16H33.87v-3.16C33.87,29.47,36.3,27.04,39.29,27.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M39.29,40.86c-1.05,0-1.91,0.86-1.91,1.91v3.57c0,1.05,0.86,1.91,1.91,1.91c1.05,0,1.91-0.86,1.91-1.91v-3.57   C41.2,41.72,40.34,40.86,39.29,40.86z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.d9fcf1751b255e7fef9ce72103e88d7f.svg";
export { ForwardRef as ReactComponent };